import * as React from 'react';
import api from '../../../services/api';
import {
  Button,
  Box,
  FormControl,
  Stack,
  Divider,
  Typography
} from '@mui/material';
import Grid from "@mui/material/Grid2";
import { useForm } from "react-hook-form";
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from "yup";
import { useStoreActions } from 'easy-peasy';
import { Checkbox,FloatField,TextField } from '../../../components';
import AvisoPopover from './AvisoPopover';
import yupnanable from '../../../services/yup-nanable.js';

const DadosEnergia = ({ano, watchEmpresaId,watchProdutoId,dadosEnergia}) => {

  let startLoading = useStoreActions((actions) => actions.nav.startLoading);
  let stopLoading = useStoreActions((actions) => actions.nav.stopLoading);

  const schema = yup.object({
    //Combustivel Renovável
    combustivelRenovavel:yup.boolean().nullable()
      .label('A minha empresa consumiu combustível renovável neste ano de referência.').default(false),
    bagacoCana:yup.number().nullable().float().nanable().nanable()
      .label('Bagaço de cana(GJ)').default(null),
    etanolHidratado:yup.number().nullable().float().nanable()
      .label('Etanol Hidratado(GJ)').default(null),
    lenha:yup.number().nullable().float().nanable()
      .label('Lenha para Queima Direta(GJ)').default(null),
    biodieselB100:yup.number().nullable().float().nanable()
      .label('Biodiesel B100(GJ)').default(null),
    biogas:yup.number().nullable().float().nanable()
      .label('Biogás(GJ)').default(null),
    carvaoVegetal:yup.number().nullable().float().nanable()
      .label('Carvão Vegetal(GJ)').default(null),
    residuosMunicipais:yup.number().nullable().float().nanable()
      .label('Resíduos Municipais(GJ)').default(null),
    residuosVegetais:yup.number().nullable().float().nanable()
      .label('Resíduos Municipais(GJ)').default(null),
    alcatraoVegetal:yup.number().nullable().float().nanable()
      .label('Alcatrão Vegetal(GJ)').default(null),
    outrosCr:yup.number().nullable().float().nanable()
      .label('Outros(GJ)').default(null),
    //Combustivel Não-Renovável
    combustivelNaoRenovavel:yup.boolean().nullable()
      .label('A minha empresa consumiu combustível não-renovável neste ano de referência.').default(false),
    coqueCarvao:yup.number().nullable().float().nanable()
      .label('Coque de Carvão Mineral(GJ)').default(null),
    alcatraoMineral:yup.number().nullable().float().nanable()
      .label('Alcatrão Mineral(GJ)').default(null),
    etanol:yup.number().nullable().float().nanable()
      .label('Etanol(GJ)').default(null),
    carvaoVapor:yup.number().nullable().float().nanable()
      .label('Carvão Vapor(GJ)').default(null),
    coquePetroleo:yup.number().nullable().float().nanable()
      .label('Coque de Petróleo(GJ)').default(null),
    gasPetroleo:yup.number().nullable().float().nanable()
      .label('Gás Liquefeito do Petróleo(GJ)').default(null),
    gasNatural:yup.number().nullable().float().nanable()
      .label('Gás Natural(GJ)').default(null),
    gasGnv:yup.number().nullable().float().nanable()
      .label('Gás NaturalVeicular (GNV)(GJ)').default(null),
    gasolinaAutomotiva:yup.number().nullable().float().nanable()
      .label('Gasolina Automotiva Pura(GJ)').default(null),
    gasolinaAviacao:yup.number().nullable().float().nanable()
      .label('Gasolina de Aviação(GJ)').default(null),
    gasGnl:yup.number().nullable().float().nanable()
      .label('Gás NaturalLíquido (GNL)(GJ)').default(null),
    lubrificantes:yup.number().nullable().float().nanable()
      .label('Lubrificantes(GJ)').default(null),
    oleoCombustivel:yup.number().nullable().float().nanable()
      .label('Óleo Combustível(GJ)').default(null),
    oleoVisto:yup.number().nullable().float().nanable()
      .label('Óleo de Visto(GJ)').default(null),
    oleoDieselPuro:yup.number().nullable().float().nanable()
      .label('Óleo Diesel Puro(GJ)').default(null),
    oleosResiduais:yup.number().nullable().float().nanable()
      .label('Óleos Residuais(GJ)').default(null),
    outrosPetroleo:yup.number().nullable().float().nanable()
      .label('Óleos Residuais(GJ)').default(null),
    petroleo:yup.number().nullable().float().nanable()
      .label('Petróleo Bruto(GJ)').default(null),
    queroseneAviacao:yup.number().nullable().float().nanable()
      .label('Querosene de Aviação(GJ)').default(null),
    residuosIndustriais:yup.number().nullable().float().nanable()
      .label('Resíduos Industriais(GJ)').default(null),
    residuosMunNr:yup.number().nullable().float().nanable()
      .label('Resíduos Municipais(GJ)').default(null),
    turfa:yup.number().nullable().float().nanable()
      .label('Turfa(GJ)').default(null),
    xistoAreias:yup.number().nullable().float().nanable()
      .label('Xisto Betuminoso e Areias Betuminosas(GJ)').default(null),
    outrosNr:yup.number().nullable().float().nanable()
      .label('Outros(GJ)').default(null),
    //Eletricidade Renovável
    eletricidadeRenovavel:yup.boolean().nullable()
      .label('A minha empresa consumiu eletricidade renovável neste ano de referência.').default(false),
    biomassa:yup.number().nullable().float().nanable()
      .label('Biomassa(GJ)').default(null),
    biomassaMadeira:yup.number().nullable().float().nanable()
      .label('Biomassa - cavaco de madeira(GJ)').default(null),
    biomassaCana:yup.number().nullable().float().nanable()
      .label('Biomassa - bagaçode cana(GJ)').default(null),
    biomassaGramineas:yup.number().nullable().float().nanable()
      .label('Biomassa - gra-míneas energéticas(GJ)').default(null),
    biomassaAgricola:yup.number().nullable().float().nanable()
      .label('Biomassa - resíduos agrícolas(GJ)').default(null),
    biomassaOutros:yup.number().nullable().float().nanable()
      .label('Biomassa - outros(GJ)').default(null),
    eolicas:yup.number().nullable().float().nanable()
      .label('Eólicas(GJ)').default(null),
    solarFotovoltaica:yup.number().nullable().float().nanable()
      .label('Solar Fotovoltaica(GJ)').default(null),
    hidreletricas:yup.number().nullable().float().nanable()
      .label('Hidrelétricas(GJ)').default(null),
    outrosEr:yup.number().nullable().float().nanable()
      .label('Outros(GJ)').default(null),
    //Eletrcidade Nao-renovavel
    eletricidadeNaoRenovavel:yup.boolean().nullable()
      .label('A minha empresa consumiu eletricidade não-renovável neste ano de referência.').default(false),
    carvao:yup.number().nullable().float().nanable()
      .label('Carvão(GJ)').default(null),
    gasNaturalEnr:yup.number().nullable().float().nanable()
      .label('Gás Natural(GJ)').default(null),
    nuclear:yup.number().nullable().float().nanable()
      .label('Nuclear(GJ)').default(null),
    oleoDiesel:yup.number().nullable().float().nanable()
      .label('Óleo Diesel(GJ)').default(null),
    oleoEnr:yup.number().nullable().float().nanable()
      .label('Óleo Combustível(GJ)').default(null),
    residuos:yup.number().nullable().float().nanable()
      .label('Resíduos(GJ)').default(null),
    coquePetroleoEnr:yup.number().nullable().float().nanable()
      .label('Coque do Petróleo(GJ)').default(null),
    outrosEnr:yup.number().nullable().float().nanable()
      .label('Outros(GJ)').default(null),
    //Eletricidade SIN
    eletricidadeSin:yup.boolean().nullable()
      .label('A minha empresa consumiu eletricidade do Sistema Integrado Nacional(SIN) neste ano de referência.').default(false),
    gridIntegrado:yup.number().nullable().float().nanable()
      .label('Grid interligado(GJ)').default(null),
    sistemaIsolado:yup.number().nullable().float().nanable()
      .label('Sistema isolado(GJ)').default(null),

    observacao: yup.string().transform((value, originalValue) => {
      return originalValue === "" ? null : value;
    }).nullable().max(1000, 'Máximo 1000 caracteres').label('Observações'),

  }).required();
  const useFormRef = useForm({
    mode: 'onTouched',
    resolver: yupResolver(schema),
  });
  const { handleSubmit, reset,setValue,
          watch, formState: { isDirty, isSubmitting }
        } = useFormRef;

  const onSave = async (data) => {
    startLoading();
    let result;
    try {
      if (data.id) {
        result = await api.http.put(`/11/energia/empresa/${watchEmpresaId}/${data.id}`, {
          ...data,
          ano,
          produtoId:watchProdutoId,
        });
      }else {
        result = await api.http.post(`/11/energia/empresa/${watchEmpresaId}`, {
          ...data,
          ano,
          produtoId:watchProdutoId,
        });
      }
      reset(result.data);
      stopLoading({ severity: 'success' });
    } catch (error) {
      stopLoading({
        message: error.toString(),
        severity: 'error'
      });
      throw error;
    };
  };

  React.useEffect(() => {
    reset(dadosEnergia);
  }, [dadosEnergia]);
  return (
    (<div>
      <Divider sx={{mt:3}}>
        <h3>Combustível Renovável</h3>
      </Divider>
      <Stack direction="column" textAlign={'left'}>
        <FormControl sx={{ my: 1}}>
          <Checkbox field="combustivelRenovavel" schema={schema} useFormRef={useFormRef}/>
        </FormControl>
      </Stack>
      <AvisoPopover/>
      <Grid container spacing={2} sx={{
        alignItems: 'center',
        '& .MuiTypography-root': { textAlign: 'right' },
        '& .MuiGrid-root': { p: 1 },
      }}>

        <Grid size={{
          md: 6
        }}>
          <Typography>Bagaço de cana:</Typography>
        </Grid>
        <Grid size={{
          md: 6
        }}>
          <FloatField
            schema={schema}
            useFormRef={useFormRef}
            field='bagacoCana'
          />
        </Grid>
        <Grid size={{
          md: 6
        }}>
          <Typography>Etanol Hidratado:</Typography>
        </Grid>
        <Grid size={{
          md: 6
        }}>
          <FloatField
            schema={schema}
            useFormRef={useFormRef}
            field='etanolHidratado'
          />
        </Grid>
        <Grid size={{
          md: 6
        }}>
          <Typography>Lenha para Queima Direta:</Typography>
        </Grid>
        <Grid size={{
          md: 6
        }}>
          <FloatField
            schema={schema}
            useFormRef={useFormRef}
            field='lenha'
          />
        </Grid>
        <Grid size={{
          md: 6
        }}>
          <Typography>Biodiesel B100: </Typography>
        </Grid>
        <Grid size={{
          md: 6
        }}>
          <FloatField
            schema={schema}
            useFormRef={useFormRef}
            field='biodieselB100'
          />
        </Grid>
        <Grid size={{
          md: 6
        }}>
          <Typography>Biogás: </Typography>
        </Grid>
        <Grid size={{
          md: 6
        }}>
          <FloatField
            schema={schema}
            useFormRef={useFormRef}
            field='biogas'
          />
        </Grid>
        <Grid size={{
          md: 6
        }}>
          <Typography>Carvão Vegetal: </Typography>
        </Grid>
        <Grid size={{
          md: 6
        }}>
          <FloatField
            schema={schema}
            useFormRef={useFormRef}
            field='carvaoVegetal'
          />
        </Grid>
        <Grid size={{
          md: 6
        }}>
          <Typography>Resíduos Municipais(fração biomassa): </Typography>
        </Grid>
        <Grid size={{
          md: 6
        }}>
          <FloatField
            schema={schema}
            useFormRef={useFormRef}
            field='residuosMunicipais'
          />
        </Grid>
        <Grid size={{
          md: 6
        }}>
          <Typography>Resíduos Vegetais: </Typography>
        </Grid>
        <Grid size={{
          md: 6
        }}>
          <FloatField
            schema={schema}
            useFormRef={useFormRef}
            field='residuosVegetais'
          />
        </Grid>
        <Grid size={{
          md: 6
        }}>
          <Typography>Alcatrão Vegetal: </Typography>
        </Grid>
        <Grid size={{
          md: 6
        }}>
          <FloatField
            schema={schema}
            useFormRef={useFormRef}
            field='alcatraoVegetal'
          />
        </Grid>
        <Grid size={{
          md: 6
        }}>
          <Typography>Outros: </Typography>
        </Grid>
        <Grid size={{
          md: 6
        }}>
          <FloatField
            schema={schema}
            useFormRef={useFormRef}
            field='outrosCr'
          />
        </Grid>
      </Grid>
      <Divider sx={{mt:3}}>
        <h3>Combustível Não-Renovável</h3>
      </Divider>
      <Stack direction="column" textAlign={'left'}>
        <FormControl sx={{ my: 1}}>
          <Checkbox field="combustivelNaoRenovavel" schema={schema} useFormRef={useFormRef}/>
        </FormControl>
      </Stack>
      <AvisoPopover/>
      <Grid container spacing={2} sx={{
        alignItems: 'center',
        '& .MuiTypography-root': { textAlign: 'right' },
        '& .MuiGrid-root': { p: 1 },
      }}>
        <Grid size={{
          md: 6
        }}>
          <Typography>Coque de Carvão Mineral: </Typography>
        </Grid>
        <Grid size={{
          md: 6
        }}>
          <FloatField
            schema={schema}
            useFormRef={useFormRef}
            field='coqueCarvao'
          />
        </Grid>
        <Grid size={{
          md: 6
        }}>
          <Typography>Alcatrão Mineral: </Typography>
        </Grid>
        <Grid size={{
          md: 6
        }}>
          <FloatField
            schema={schema}
            useFormRef={useFormRef}
            field='alcatraoMineral'
          />
        </Grid>
        <Grid size={{
          md: 6
        }}>
          <Typography>Etanol: </Typography>
        </Grid>
        <Grid size={{
          md: 6
        }}>
          <FloatField
            schema={schema}
            useFormRef={useFormRef}
            field='etanol'
          />
        </Grid>
        <Grid size={{
          md: 6
        }}>
          <Typography>Carvão Vapor: </Typography>
        </Grid>
        <Grid size={{
          md: 6
        }}>
          <FloatField
            schema={schema}
            useFormRef={useFormRef}
            field='carvaoVapor'
          />
        </Grid>
        <Grid size={{
          md: 6
        }}>
          <Typography>Coque de Petróleo: </Typography>
        </Grid>
        <Grid size={{
          md: 6
        }}>
          <FloatField
            schema={schema}
            useFormRef={useFormRef}
            field='coquePetroleo'
          />
        </Grid>
        <Grid size={{
          md: 6
        }}>
          <Typography>Gás Liquefeitodo Petróleo: </Typography>
        </Grid>
        <Grid size={{
          md: 6
        }}>
          <FloatField
            schema={schema}
            useFormRef={useFormRef}
            field='gasPetroleo'
          />
        </Grid>
        <Grid size={{
          md: 6
        }}>
          <Typography>Gás Natural: </Typography>
        </Grid>
        <Grid size={{
          md: 6
        }}>
          <FloatField
            schema={schema}
            useFormRef={useFormRef}
            field='gasNatural'
          />
        </Grid>
        <Grid size={{
          md: 6
        }}>
          <Typography>Gás Natural Veicular (GNV): </Typography>
        </Grid>
        <Grid size={{
          md: 6
        }}>
          <FloatField
            schema={schema}
            useFormRef={useFormRef}
            field='gasGnv'
          />
        </Grid>
        <Grid size={{
          md: 6
        }}>
          <Typography>Gasolina Automotiva Pura: </Typography>
        </Grid>
        <Grid size={{
          md: 6
        }}>
          <FloatField
            schema={schema}
            useFormRef={useFormRef}
            field='gasolinaAutomotiva'
          />
        </Grid>
        <Grid size={{
          md: 6
        }}>
          <Typography>Gasolina de Aviação: </Typography>
        </Grid>
        <Grid size={{
          md: 6
        }}>
          <FloatField
            schema={schema}
            useFormRef={useFormRef}
            field='gasolinaAviacao'
          />
        </Grid>
        <Grid size={{
          md: 6
        }}>
          <Typography>Gás NaturalLíquido (GNL): </Typography>
        </Grid>
        <Grid size={{
          md: 6
        }}>
          <FloatField
            schema={schema}
            useFormRef={useFormRef}
            field='gasGnl'
          />
        </Grid>
        <Grid size={{
          md: 6
        }}>
          <Typography>Lubrificantes: </Typography>
        </Grid>
        <Grid size={{
          md: 6
        }}>
          <FloatField
            schema={schema}
            useFormRef={useFormRef}
            field='lubrificantes'
          />
        </Grid>
        <Grid size={{
          md: 6
        }}>
          <Typography>Óleo Combustível: </Typography>
        </Grid>
        <Grid size={{
          md: 6
        }}>
          <FloatField
            schema={schema}
            useFormRef={useFormRef}
            field='oleoCombustivel'
          />
        </Grid>
        <Grid size={{
          md: 6
        }}>
          <Typography>Óleo de Visto: </Typography>
        </Grid>
        <Grid size={{
          md: 6
        }}>
          <FloatField
            schema={schema}
            useFormRef={useFormRef}
            field='oleoVisto'
          />
        </Grid>
        <Grid size={{
          md: 6
        }}>
          <Typography>Óleo Diesel Puro: </Typography>
        </Grid>
        <Grid size={{
          md: 6
        }}>
          <FloatField
            schema={schema}
            useFormRef={useFormRef}
            field='oleoDieselPuro'
          />
        </Grid>
        <Grid size={{
          md: 6
        }}>
          <Typography>Óleos Residuais: </Typography>
        </Grid>
        <Grid size={{
          md: 6
        }}>
          <FloatField
            schema={schema}
            useFormRef={useFormRef}
            field='oleosResiduais'
          />
        </Grid>
        <Grid size={{
          md: 6
        }}>
          <Typography>Outros Produtos de Petróleo: </Typography>
        </Grid>
        <Grid size={{
          md: 6
        }}>
          <FloatField
            schema={schema}
            useFormRef={useFormRef}
            field='outrosPetroleo'
          />
        </Grid>
        <Grid size={{
          md: 6
        }}>
          <Typography>Petróleo Bruto:</Typography>
        </Grid>
        <Grid size={{
          md: 6
        }}>
          <FloatField
            schema={schema}
            useFormRef={useFormRef}
            field='petroleo'
          />
        </Grid>
        <Grid size={{
          md: 6
        }}>
          <Typography>Querosene de Aviação:</Typography>
        </Grid>
        <Grid size={{
          md: 6
        }}>
          <FloatField
            schema={schema}
            useFormRef={useFormRef}
            field='queroseneAviacao'
          />
        </Grid>
        <Grid size={{
          md: 6
        }}>
          <Typography>Resíduos Industriais:</Typography>
        </Grid>
        <Grid size={{
          md: 6
        }}>
          <FloatField
            schema={schema}
            useFormRef={useFormRef}
            field='residuosIndustriais'
          />
        </Grid>
        <Grid size={{
          md: 6
        }}>
          <Typography>Resíduos Municipais:</Typography>
        </Grid>
        <Grid size={{
          md: 6
        }}>
          <FloatField
            schema={schema}
            useFormRef={useFormRef}
            field='residuosMunNr'
          />
        </Grid>
        <Grid size={{
          md: 6
        }}>
          <Typography>Turfa:</Typography>
        </Grid>
        <Grid size={{
          md: 6
        }}>
          <FloatField
            schema={schema}
            useFormRef={useFormRef}
            field='turfa'
          />
        </Grid>
        <Grid size={{
          md: 6
        }}>
          <Typography>Xisto Betuminoso e Areias Betuminosas:</Typography>
        </Grid>
        <Grid size={{
          md: 6
        }}>
          <FloatField
            schema={schema}
            useFormRef={useFormRef}
            field='xistoAreias'
          />
        </Grid>
        <Grid size={{
          md: 6
        }}>
          <Typography>Outros:</Typography>
        </Grid>
        <Grid size={{
          md: 6
        }}>
          <FloatField
            schema={schema}
            useFormRef={useFormRef}
            field='outrosNr'
          />
        </Grid>
      </Grid>
      <Divider sx={{mt:3}}>
        <h3>Eletricidade Renovável</h3>
      </Divider>
      <Stack direction="column" textAlign={'left'}>
        <FormControl sx={{ my: 1}}>
          <Checkbox field="eletricidadeRenovavel" schema={schema} useFormRef={useFormRef}/>
        </FormControl>
      </Stack>
      <AvisoPopover/>
      <Grid container spacing={2} sx={{
        alignItems: 'center',
        '& .MuiTypography-root': { textAlign: 'right' },
        '& .MuiGrid-root': { p: 1 },
      }}>
        <Grid size={{
          md: 6
        }}>
          <Typography>Biomassa:</Typography>
        </Grid>
        <Grid size={{
          md: 6
        }}>
          <FloatField
            schema={schema}
            useFormRef={useFormRef}
            field='biomassa'
          />
        </Grid>
        <Grid size={{
          md: 6
        }}>
          <Typography>Biomassa - cavaco de madeira:</Typography>
        </Grid>
        <Grid size={{
          md: 6
        }}>
          <FloatField
            schema={schema}
            useFormRef={useFormRef}
            field='biomassaMadeira'
          />
        </Grid>
        <Grid size={{
          md: 6
        }}>
          <Typography>Biomassa - bagaço de cana:</Typography>
        </Grid>
        <Grid size={{
          md: 6
        }}>
          <FloatField
            schema={schema}
            useFormRef={useFormRef}
            field='biomassaCana'
          />
        </Grid>
        <Grid size={{
          md: 6
        }}>
          <Typography>Biomassa - gra-míneas energéticas:</Typography>
        </Grid>
        <Grid size={{
          md: 6
        }}>
          <FloatField
            schema={schema}
            useFormRef={useFormRef}
            field='biomassaGramineas'
          />
        </Grid>
        <Grid size={{
          md: 6
        }}>
          <Typography>Biomassa - resíduos agrícolas:</Typography>
        </Grid>
        <Grid size={{
          md: 6
        }}>
          <FloatField
            schema={schema}
            useFormRef={useFormRef}
            field='biomassaAgricola'
          />
        </Grid>
        <Grid size={{
          md: 6
        }}>
          <Typography>Biomassa - outros:</Typography>
        </Grid>
        <Grid size={{
          md: 6
        }}>
          <FloatField
            schema={schema}
            useFormRef={useFormRef}
            field='biomassaOutros'
          />
        </Grid>
        <Grid size={{
          md: 6
        }}>
          <Typography>Eólicas:</Typography>
        </Grid>
        <Grid size={{
          md: 6
        }}>
          <FloatField
            schema={schema}
            useFormRef={useFormRef}
            field='eolicas'
          />
        </Grid>
        <Grid size={{
          md: 6
        }}>
          <Typography>Solar Fotovoltaica:</Typography>
        </Grid>
        <Grid size={{
          md: 6
        }}>
          <FloatField
            schema={schema}
            useFormRef={useFormRef}
            field='solarFotovoltaica'
          />
        </Grid>
        <Grid size={{
          md: 6
        }}>
          <Typography>Hidrelétricas:</Typography>
        </Grid>
        <Grid size={{
          md: 6
        }}>
          <FloatField
            schema={schema}
            useFormRef={useFormRef}
            field='hidreletricas'
          />
        </Grid>
        <Grid size={{
          md: 6
        }}>
          <Typography>Outros:</Typography>
        </Grid>
        <Grid size={{
          md: 6
        }}>
          <FloatField
            schema={schema}
            useFormRef={useFormRef}
            field='outrosEr'
          />
        </Grid>
      </Grid>
      <Divider sx={{mt:3}}>
        <h3>Eletetricidade Não-Renovável</h3>
      </Divider>
      <Stack direction="row" textAlign={'left'}>
        <FormControl sx={{ my: 1}}>
          <Checkbox field="eletricidadeNaoRenovavel" schema={schema} useFormRef={useFormRef}/>
        </FormControl>
      </Stack>
      <AvisoPopover/>
      <Grid container spacing={2} sx={{
        alignItems: 'center',
        '& .MuiTypography-root': { textAlign: 'right' },
        '& .MuiGrid-root': { p: 1 },
      }}>

        <Grid size={{
          md: 6
        }}>
          <Typography>Carvão:</Typography>
        </Grid>
        <Grid size={{
          md: 6
        }}>
          <FloatField
            schema={schema}
            useFormRef={useFormRef}
            field='carvao'
          />
        </Grid>
        <Grid size={{
          md: 6
        }}>
          <Typography>Gás Natural:</Typography>
        </Grid>
        <Grid size={{
          md: 6
        }}>
          <FloatField
            schema={schema}
            useFormRef={useFormRef}
            field='gasNaturalEnr'
          />
        </Grid>
        <Grid size={{
          md: 6
        }}>
          <Typography>Nuclear</Typography>
        </Grid>
        <Grid size={{
          md: 6
        }}>
          <FloatField
            schema={schema}
            useFormRef={useFormRef}
            field='nuclear'
          />
        </Grid>
        <Grid size={{
          md: 6
        }}>
          <Typography>Óleo Diesel:</Typography>
        </Grid>
        <Grid size={{
          md: 6
        }}>
          <FloatField
            schema={schema}
            useFormRef={useFormRef}
            field='oleoDiesel'
          />
        </Grid>
        <Grid size={{
          md: 6
        }}>
          <Typography>Óleo Combustível:</Typography>
        </Grid>
        <Grid size={{
          md: 6
        }}>
          <FloatField
            schema={schema}
            useFormRef={useFormRef}
            field='oleoEnr'
          />
        </Grid>
        <Grid size={{
          md: 6
        }}>
          <Typography>Resíduos:</Typography>
        </Grid>
        <Grid size={{
          md: 6
        }}>
          <FloatField
            schema={schema}
            useFormRef={useFormRef}
            field='residuos'
          />
        </Grid>
        <Grid size={{
          md: 6
        }}>
          <Typography>Coque do Petróleo:</Typography>
        </Grid>
        <Grid size={{
          md: 6
        }}>
          <FloatField
            schema={schema}
            useFormRef={useFormRef}
            field='coquePetroleoEnr'
          />
        </Grid>
        <Grid size={{
          md: 6
        }}>
          <Typography>Outros:</Typography>
        </Grid>
        <Grid size={{
          md: 6
        }}>
          <FloatField
            schema={schema}
            useFormRef={useFormRef}
            field='outrosEnr'
          />
        </Grid>
      </Grid>
      <Divider sx={{mt:3}}>
        <h3>Eletricidade SIN</h3>
      </Divider>
      <Stack direction="row" textAlign={'left'}>
        <FormControl sx={{ my: 1}}>
          <Checkbox field="eletricidadeSin" schema={schema} useFormRef={useFormRef}/>
        </FormControl>
      </Stack>
      <AvisoPopover/>
      <Grid container spacing={2} sx={{
        alignItems: 'center',
        '& .MuiTypography-root': { textAlign: 'right' },
        '& .MuiGrid-root': { p: 1 },
      }}>
        <Grid size={{
          md: 6
        }}>
          <Typography>Grid interligado:</Typography>
        </Grid>
        <Grid size={{
          md: 6
        }}>
          <FloatField
            schema={schema}
            useFormRef={useFormRef}
            field='gridIntegrado'
          />
        </Grid>
        <Grid size={{
          md: 6
        }}>
          <Typography>Sistema isolado:</Typography>
        </Grid>
        <Grid size={{
          md: 6
        }}>
          <FloatField
            schema={schema}
            useFormRef={useFormRef}
            field='sistemaIsolado'
          />
        </Grid>
      </Grid>
      <Divider sx={{mt:3}}>
        <h3>Observações</h3>
      </Divider>
      <FormControl sx={{ my: 1 }} fullWidth>
        <TextField
          field="observacao"
          type="text"
          multiline rows={4}
          schema={schema}
          useFormRef={useFormRef}
          inputProps={{ maxLength: 1000 }} />
      </FormControl>
      <Box>
        <Button variant="outlined" sx={{ mr: 2 }}
                onClick={()=>{reset();}} disabled={!isDirty || isSubmitting}>
          CANCELAR
        </Button>
        <Button
          type="submit"
          variant="contained"
          sx={{ m: 1 }}
          onClick={handleSubmit(onSave)}
          disabled={!isDirty || isSubmitting}
        >
          Salvar
        </Button>
      </Box>
    </div>)
  );
};

export default DadosEnergia;
